import { apiFetch, apiFetchBlob, apiSendForm } from './client';
import type { BulkApplyResult, BulkGroup, BulkImport, BulkPreview } from './types';

export function listBulkGroups(): Promise<BulkGroup[]> {
  return apiFetch<BulkGroup[]>('/api/qr-codes/bulk/groups');
}

export function exportBulkCsv(groupId: string): Promise<Blob> {
  return apiFetchBlob(`/api/qr-codes/bulk/export?groupId=${encodeURIComponent(groupId)}`);
}

function fileForm(file: File): FormData {
  const form = new FormData();
  form.append('file', file);
  return form;
}

export function previewBulkImport(groupId: string, file: File): Promise<BulkPreview> {
  return apiSendForm<BulkPreview>(`/api/qr-codes/bulk/preview?groupId=${encodeURIComponent(groupId)}`, fileForm(file));
}

export function applyBulkImport(groupId: string, fingerprint: string, file: File): Promise<BulkApplyResult> {
  return apiSendForm<BulkApplyResult>(
    `/api/qr-codes/bulk/apply?groupId=${encodeURIComponent(groupId)}&fingerprint=${encodeURIComponent(fingerprint)}`,
    fileForm(file),
  );
}

export function listBulkImports(groupId: string, mine = false): Promise<BulkImport[]> {
  return apiFetch<BulkImport[]>(`/api/qr-codes/bulk/imports?groupId=${encodeURIComponent(groupId)}&mine=${mine}`);
}


export function downloadBulkImportFile(importId: string): Promise<Blob> {
  return apiFetchBlob(`/api/qr-codes/bulk/imports/${encodeURIComponent(importId)}/file`);
}
